import { new_counter } from './Math/Math';

export { getDaysArray } from './getDaysArray/getDaysArray';
export { getLetterTimeAgo } from './getLetterTimeAgo/getLetterTimeAgo';
export { getAllAvailableTags } from './getAllAvailableTags/getAllAvailableTags';
export { getProductAmount } from './getProductAmount/getProductAmount';
export { getFilterRequest } from './getFilterRequest/getFilterRequest';
export { handleSortClick } from './handleSortClick/handleSortClick';
export { getWarrantyStatus } from './getWarrantyStatus/getWarrantyStatus';
export { formatDate } from './formatDate/formatDate';
export { getEquipmentValue } from './getEquipmentvalue/getEquipmentValue';
export { getSoftwareValue } from './getSoftwareValue/getSoftwareValue';
export { getStudioServiceValue } from './getStudioServiceValue/getStudioServiceValue';
export { getMiscellaneousValue } from './getMiscellaneousValue/getMiscellaneousValue';
export { getLicenseStatus } from './getLicenseStatus/getLicenseStatus';
export { getProductMatchStatus } from './getProductMatchStatus/getProductMatchStatus';
export { isImageUrl } from './isImageUrl/isImageUrl';
export { getUpdateFlagColor } from './getUpdateFlagColor/getUpdateFlagColor';
export { countUpdatesFilter } from './countUpdatesFilter/countUpdatesFilter';
export { updateBeamUrl } from './updateBeamUrl/updateBeamUrl';
export { getStatusColor } from './getStatusColor/getStatusColor';
export { extractUrl } from './updateBeamUrl/updateBeamUrl';
export { getPermissionData } from './getPermissionData/getPermissionData';
export { getResourceSource } from './getResourceSource/getResourceSource';
export { isArrayOfObjectsEqual } from './isArrayOfObjectsEqual/isArrayOfObjectsEqual';
export { getTagFontColor } from './getTagFontColor/getTagFontColor';
export { removeDuplicatesArray } from './removeDuplicatesArray/removeDuplicatesArray';
export { maskString } from './maskString/maskString';
export { getPage } from './Math/paginate';
export { isBetween } from './Math/between';
export { timeSince } from './timeSince/timeSince';
export * as Result from './result';
export { default as AppError } from './AppError';
export { cx } from './cx';
export { filterEmptyParams } from './filterEmptyParams';
export { getDefaultTagBackground } from './getDefaultTagBackground';
export { getDefaultTagColor } from './getDefaultTagColor';
export { getRefreshInterceptor } from './getRefreshInterceptor';
export { isAppErrAndStatus } from './isAppErrAndStatus';
export { getStableNow } from './getStableNow';
export { omit } from './omit';
export { pick } from './pick';
export { setAttr } from './setAttr';
export { typeCSS } from './TypeCSS.styles';

export const Counter = new_counter(Math.floor(Math.random() * 9999999));
